import { Button, withStyles } from "@material-ui/core"

const OutlinedButton = withStyles((theme) => ({
    root: {
        color: '#0085FF',
        backgroundColor: 'transparent',
        border: '1px solid #0085FF',
        borderRadius: '100px',
        boxShadow: '0px 2px 2px rgba(46, 155, 255, 0.5)',
        fontWeight: 700,
        textTransform: 'capitalize',
        padding: '10px 20px',
        '&:hover': {
            boxShadow: '0px 4px 4px rgba(46, 155, 255, 0.5)',
        }
    }
}))(Button);

export default OutlinedButton